export enum FaxDirection {
  Inbound = 'inbound',
  Outbound = 'outbound',
}

export enum FaxStatus {
  Succeeded = 'succeeded',
  Failed = 'failed',
  Pending = 'pending',
}

export interface Fax {
  created_at: string
  direction: FaxDirection
  extension: {
    id: number
    name: string
    number: string
  }
  from_phone_number: {
    phone_number: string
    location: string
  }
  id: number
  pbx_id: number
  read_at: string | null // ISO timestamp
  sent_at: string
  status: FaxStatus
  to_phone_number: {
    phone_number: string
    location: string
  }
  updated_at: string
}

/**
 * Note: The additional fields in this object are not available on the collection
 * because they may contain sensitive data and require access logging
 */
export interface FaxInstance extends Fax {
  file_name: string
  file_url: string
  thumbnail_url: string
}
